<script>
	const _ = require('underscore');
	const Q = require('q');
	const model = require('model/model');
	const Vue = require('vue');
	const scrollManager = require('ui/core/scrollManager');
	const { v4: uuidv4 } = require('uuid');
	const utilities = require('utilities');
	const aadVocabUtilities = require('utilities/aadVocabUtilities');
	const getGraphicOrganizer = aadVocabUtilities.getGraphicOrganizer;
	const createNode = aadVocabUtilities.createNode;
	const updateNode = aadVocabUtilities.updateNode;
	const deleteNode = aadVocabUtilities.deleteNode;

	let rootId = uuidv4();
	const demoData = {
		nodes: [
			{
				id: rootId,
				root: true,
				word: '-s',
				text: 'More than one'
			},
			{
				id: uuidv4(),
				word: 'trains',
				linkText: 'train',
				parentId: rootId
			},
			{
				id: uuidv4(),
				word: 'subways',
				linkText: 'subway',
				parentId: rootId
			},
			{
				id: uuidv4(),
				word: 'ropes',
				linkText: 'rope',
				parentId: rootId
			},
			{
				id: uuidv4(),
				word: 'cars',
				linkText: 'car',
				parentId: rootId
			}
		]
	};

	module.exports = {
		props: ['aid', 'product', 'demo', 'organizerData', 'teacher'],
		modelData: ['graphicOrganizer', 'graphicOrganizerInstructionsDismiss', 'userContext', 'printing'],
		components: {
			'load-mask': require('components/load-mask.vue').default,
			'graphic-organizer': require('components/graphic-organizer.vue').default,
			'validated-form': require('components/validated-form.vue').default,
			'validated-textarea': require('components/validated-textarea.vue').default,
			'validated-input': require('components/validated-input.vue').default,
			'article-overlay': require('components/article-overlay.vue').default,
			'word-detective-icon': require('components/svg/word-detective-icon.vue').default
		},
		data() {
			return {
				loading: true,
				addText: null,
				editParentId: null,
				editWordPartDef: '',
				editWord: '',
				editWordAndPart: '',
				chosenArticle: null,
				editNode: null,
				allowDelete: false,
				createdNodeId: null
			};
		},
		computed: {
			activity() {
				let product = this.product;
				let value = null;
				if (product && product.word_detective) {
					value = product.word_detective;
				}
				return value;
			},
			affix() {
				let activity = this.activity;
				let value = null;
				if (activity && activity.affix && activity.affix.fragments) {
					value = activity.affix.fragments.join(', ');
				}
				return value;
			},
			cleanWords() {
				return (this.activity && this.activity.teacher_word_bank) || [];
			},
			articleBank() {
				let product = this.product;
				let activity = this.activity;
				let bank = [];

				if (activity && activity.playing_words) {
					let articleMap = activity.playing_words.reduce((acc, word) => {
						word.texts.forEach(text => {
							if (acc[text]) {
								acc[text].push(word.word);
							} else {
								acc[text] = [word.word];
							}
						});
						return acc;
					}, {});
					bank = Object.keys(articleMap).map(pid => {
						let article = product.articles[pid];
						return _.assign(
							{
								pid: pid,
								words: articleMap[pid]
							},
							article
						);
					});
				}
				return bank;
			},
			organizer() {
				let organizerData = this.organizerData;
				let graphicOrganizer = this.graphicOrganizer;
				let product = this.product;
				let org = null;

				if (product && product.word_detective) {
					this.addText = null;

					if (organizerData) {
						org = _.assign({}, organizerData);
					} else if (graphicOrganizer) {
						org = _.assign({}, graphicOrganizer);

						if (org && org.nodes && org.nodes.length === 0) {
							this.addText = 'Click the + to define the word part!';
							let affix = this.affix;
							org = _.assign({}, org, {
								nodes: [
									{
										id: 'init',
										word: affix,
										root: true
									}
								]
							});
						} else if (org && org.nodes && org.nodes.length < 3) {
							this.addText = 'Click the + to add a word!';
						}
					}
				}
				return org;
			},
			rootNode() {
				let graphicOrganizer = this.graphicOrganizer;
				let node = null;
				if (graphicOrganizer && graphicOrganizer.nodes && graphicOrganizer.nodes.length) {
					graphicOrganizer.nodes.some(n => {
						if (n.root) {
							node = n;
							return true;
						}
						return false;
					});
				}
				return node;
			},
			overlayArticles() {
				let product = this.product;
				let chosenArticle = this.chosenArticle;
				let overlayArticleList = chosenArticle ? [chosenArticle] : null;
				let articles = null;

				if (product && overlayArticleList && overlayArticleList.length) {
					articles = overlayArticleList;
				}

				return articles;
			},
			rootText() {
				let rootNode = this.rootNode;
				let text = null;
				if (rootNode && rootNode.text) {
					text = utilities.linebreakStr(rootNode.text);
				}
				return text;
			},
			isStudent() {
				let userContext = this.userContext;
				let student = false;
				if (userContext && userContext.classCode) {
					student = true;
				}
				return student;
			}
		},
		methods: {
			onCreateNodeClick(parentNode) {
				if (this.organizerData) {
					return;
				}

				this.onEndEdit();
				this.editParentId = parentNode.id;

				if (parentNode.id === 'init') {
					utilities.openModal('#word-detective-init');
				} else if (parentNode.id) {
					utilities.openModal('#word-detective-add-word');
				}
			},
			onInitSubmit() {
				let aid = this.aid;
				let editNode = this.editNode;
				let parentId = undefined;
				let word = this.affix;
				let linkText = undefined;
				let text = this.editWordPartDef;
				let prms = Q();

				this.onEndEdit();

				this.loading = true;
				if (editNode) {
					prms = updateNode(aid, editNode.id, editNode.parentId, word, text, linkText);
				} else if (text) {
					prms = createNode(aid, parentId, word, text, linkText);
				}

				prms.then(() => (this.loading = false)).done();
			},
			onCreateNodeSubmit() {
				let aid = this.aid;
				let parentId = this.editParentId;
				let editNode = this.editNode;
				let word = this.editWordAndPart;
				let linkText = this.editWord;
				let text = undefined;
				let prms = Q();

				this.onEndEdit();

				this.loading = true;
				if (editNode) {
					prms = updateNode(aid, editNode.id, editNode.parentId, word, text, linkText);
				} else if (parentId) {
					prms = createNode(aid, parentId, word, text, linkText);
				}

				prms
					.then(node => {
						this.loading = false;
						if (!editNode) {
							this.createdNodeId = node.id;
						}
					})
					.done();
			},
			onNodeClick(node) {
				if (node.id === 'init') {
					this.onCreateNodeClick(node);
				} else if (!node.parentId) {
					utilities.openModal('#word-detective-init');

					this.editNode = node;
					this.editWordPartDef = node.text;

					this.refreshRootForm();
				} else if (node && this.$refs.editForm) {
					this.onEndEdit();

					utilities.openModal('#word-detective-add-word');

					this.editNode = node;
					this.editWord = node.linkText;
					this.editWordAndPart = node.word;
					this.allowDelete = this.isNodeLeaf(node.id);

					this.refreshForm();
				}
			},
			onEndEdit() {
				utilities.closeModals();
				this.editWord = '';
				this.editParentId = null;
				this.editWordPartDef = '';
				this.editWordAndPart = '';
				this.editNode = null;
				this.allowDelete = false;
			},
			refreshForm() {
				if (this.$refs && this.$refs.editForm) {
					Vue.nextTick(() => this.$refs.editForm.change());
				}
			},
			refreshRootForm() {
				if (this.$refs && this.$refs.rootForm) {
					Vue.nextTick(() => this.$refs.rootForm.change());
				}
			},
			setOverlayArticles(article) {
				this.chosenArticle = article;
				if (this.$refs.organizerOverlayContainer) {
					scrollManager(this.$refs.organizerOverlayContainer, {
						priority: 2,
						duration: 500
					});
				}
			},
			closeOverlay() {
				const articleBank = this.articleBank || [];
				const chosenIndex = articleBank.indexOf(this.chosenArticle);

				if (chosenIndex !== -1) {
					this.$refs.articleBankLink[chosenIndex].focus();
				}

				this.chosenArticle = null;
			},
			isNodeLeaf(id) {
				let organizer = this.organizer;
				let nodes = organizer && organizer.nodes;
				let isLeaf = false;
				if (nodes && nodes.length) {
					isLeaf = !nodes.some(n => n.parentId === id);
				}
				return isLeaf;
			},
			onDeleteNode() {
				let editNode = this.editNode;
				let id = editNode && editNode.id;
				let aid = this.aid;
				let isLeaf = this.isNodeLeaf(id);

				this.onEndEdit();
				if (id && isLeaf) {
					this.loading = true;
					deleteNode(aid, id)
						.then(() => (this.loading = false))
						.done();
				}
			},
			onHelpClick() {
				utilities.openModal('#word-detective-instructions');
			},
			dismissInstructions() {
				utilities.closeModals();
				let dismiss = model.get('graphicOrganizerInstructionsDismiss') || {};
				dismiss.wordDetective = true;
				model.set('graphicOrganizerInstructionsDismiss', dismiss);
			}
		},
		mounted() {
			let dismiss = model.get('graphicOrganizerInstructionsDismiss') || {};
			model.remove('graphicOrganizer');

			if (!this.demo && !this.organizerData && this.aid) {
				getGraphicOrganizer(this.aid)
					.then(() => (this.loading = false))
					.done();
			}

			if (this.demo) {
				this.$emit('update:organizerData', demoData);
				this.loading = false;
			}

			if (this.organizerData) {
				this.loading = false;
			} else if (!dismiss.wordDetective && this.isStudent) {
				Vue.nextTick(() => {
					utilities.openModal('#word-detective-instructions');
				});
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';

	.word-detective {
		position: relative;

		#word-detective-add-word {
			.modal-window-wrap {
				max-width: $max-width-inner;
			}
		}

		.loading-container .loading-plaque {
			border: 2px solid $c-blue;
		}

		&.graphic-organizer-activity .modal.graphic-organizer-modal .modal-content .word-detective-init-form {
			.word-detective-root-node-form {
				margin: 1rem auto;
			}
		}

		form.validated-form.word-detective-edit-form {
			.input-wrapper {
				input[type='text'].validated-input {
					border: 2px solid $c-blue;
					padding: 2rem 1rem;
					border-radius: 2rem;
					margin: 0;

					&:not(.date-input) + label {
						margin-top: calc(-3rem - 0px);
					}
				}
			}
		}
	}

	.word-detective-print {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		.word-detective-row {
			display: flex;
		}

		.word-detective-blank,
		.word-detective-center,
		.word-detective-bank {
			border: 1px solid #000000;
		}

		.word-detective-branch {
			flex-basis: 15rem;
			display: flex;
			position: relative;
			align-items: center;

			.line {
				flex-basis: 1rem;
				border-bottom: 1px dashed #000;
			}

			&.wd-vertical {
				flex-direction: column;
				flex-basis: auto;

				.line {
					border-left: 1px dashed #000;
				}
			}

			&.spacer {
				flex-basis: 17.5rem;
			}
		}

		.word-detective-blank {
			width: 6.5rem;
			height: 3rem;
			border-radius: 1.5rem;
			background-color: #fff;
			z-index: 1;
		}

		.word-detective-center {
			width: 11.5rem;
			height: 11.5rem;
			border-radius: 5.75rem;
			padding: 1rem;
			background-color: #fff;
			z-index: 1;
			display: flex;
			flex-direction: column;
			justify-content: center;
			text-align: center;
		}

		.word-detective-affix {
			font-weight: 700;
		}

		.word-detective-definition {
			font-size: 0.75rem;
		}

		.word-bank-print {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-bottom: 2rem;
			padding: 1rem;
			border: 1px solid #000000;
		}
	}
</style>
<template>
	<div class="word-detective graphic-organizer-activity">
		<load-mask v-if="loading"></load-mask>
		<div
			ref="organizerOverlayContainer"
			class="organizer-overlay-container">
			<graphic-organizer
				:organizer="organizer"
				:add-text="addText"
				:on-add-click="onCreateNodeClick"
				:on-node-click="!demo && !organizerData && onNodeClick"
				:on-help-click="onHelpClick"
				:zoom-to="createdNodeId">
			</graphic-organizer>
			<article-overlay
				v-if="overlayArticles && overlayArticles.length"
				:articles="overlayArticles"
				:highlight-words="chosenArticle && chosenArticle.words"
				:on-close-click="closeOverlay"></article-overlay>
		</div>
		<modal
			id="word-detective-instructions"
			class="graphic-organizer-modal"
			:closeable="false">
			<div
				slot="content"
				class="instructions">
				<div class="instructions-header">
					<word-detective-icon></word-detective-icon>
					<h3>Become a Word Detective!</h3>
				</div>
				<p>Exploring words and word parts will help you become master detectives who can figure out the meaning of any word!</p>
				<ol>
					<li>Together as a class, you will define the word part and explore how it changes a word’s meaning.</li>
					<li>
						Now be word detectives! Look through articles you read this week for words you can add this word part to. Put the word in the first bubble on a
						branch on your map and then add the word part in the second bubble.
					</li>
				</ol>
				<p>Have fun creating real or imaginary words!</p>
				<button
					class="button -centered"
					@click="dismissInstructions">
					OK
				</button>
			</div>
		</modal>
		<div
			v-if="articleBank && articleBank.length"
			class="word-bank">
			<div class="word-bank-title word-bank-cell">Find More Playing Words!</div>
			<div class="word-bank-list">
				<a
					v-for="article in articleBank"
					:key="article.title"
					href="javascript:void(0)"
					aria-haspopup="dialog"
					@click="setOverlayArticles(article)"
					ref="articleBankLink"
					class="word-bank-word word-bank-cell">
					{{ article.title }}
				</a>
			</div>
		</div>
		<div
			v-if="printing"
			class="word-detective-print">
			<div>
				<h1 class="margin-none">Word Detective Graphic Organizer</h1>
				<p class="margin-top-xs margin-bottom-none">{{ product.title }}</p>
			</div>
			<div>
				<div class="word-detective-row">
					<div class="word-detective-branch spacer"></div>
					<div class="word-detective-branch wd-vertical">
						<div class="word-detective-blank"></div>
						<div class="line"></div>
						<div class="word-detective-blank"></div>
						<div class="line"></div>
					</div>
					<div class="word-detective-branch spacer"></div>
				</div>
				<div class="word-detective-row">
					<div class="word-detective-branch wd-left">
						<div class="word-detective-blank"></div>
						<div class="line"></div>
						<div class="word-detective-blank"></div>
						<div class="line"></div>
					</div>
					<div class="word-detective-center">
						<div class="word-detective-affix">{{ affix }}</div>
						<div class="word-detective-definition">{{ activity.affix.definition }}</div>
					</div>
					<div class="word-detective-branch wd-right">
						<div class="line"></div>
						<div class="word-detective-blank"></div>
						<div class="line"></div>
						<div class="word-detective-blank"></div>
					</div>
				</div>
				<div class="word-detective-row">
					<div class="word-detective-branch spacer"></div>
					<div class="word-detective-branch wd-vertical">
						<div class="line"></div>
						<div class="word-detective-blank"></div>
						<div class="line"></div>
						<div class="word-detective-blank"></div>
					</div>
					<div class="word-detective-branch spacer"></div>
				</div>
			</div>
			<div class="word-bank-print">
				<h2 class="word-bank-print-title margin-none">Word Bank</h2>
				<strong
					v-for="word in cleanWords"
					:key="word"
					>{{ word }}</strong
				>
			</div>
		</div>
		<modal
			id="word-detective-init"
			class="graphic-organizer-modal"
			:ok="false"
			:closeable="false">
			<!-- <template slot="header-container">
				<h2>Begin Word Detective!</h2>
			</template> -->
			<template slot="content">
				<validated-form
					ref="rootForm"
					class="word-detective-init-form"
					:on-submit="onInitSubmit">
					<div class="word-detective-root-node-form">
						<div class="word-part text-centered">
							{{ affix }}
						</div>
						<validated-textarea
							class="word-part-definition print-hidden"
							:value="editWordPartDef"
							@input.native="editWordPartDef = $event.target.value"
							placeholder="Definition"
							maxlength="200"
							required>
						</validated-textarea>
					</div>
					<div class="text-centered">
						<button
							class="save-notif button"
							type="submit">
							Save
						</button>
						<button
							class="cancel-notif button -outline"
							type="button"
							@click="onEndEdit">
							Cancel
						</button>
					</div>
				</validated-form>
			</template>
		</modal>
		<modal
			id="word-detective-add-word"
			class="graphic-organizer-modal"
			:ok="false"
			:closeable="false">
			<!-- <template slot="header-container">
				<h2>Add a Word</h2>
			</template> -->
			<template slot="content">
				<validated-form
					ref="editForm"
					class="word-detective-edit-form"
					:on-submit="onCreateNodeSubmit">
					<div class="node-container-form">
						<div class="word-detective-root-node-form text-centered margin-top-medium margin-bottom-medium">
							<div class="word-part">{{ rootNode && rootNode.word }}</div>
							<div
								class="word-part-definition"
								:title="rootNode && rootNode.text">
								{{ rootText }}
							</div>
						</div>
						<div class="line">&nbsp;</div>
						<div class="input-wrapper text-centered">
							<validated-input
								class="word text-centered"
								type="text"
								:debounce-delay="50"
								required
								v-model.trim="editWord"
								name="editWord"
								maxlength="22"></validated-input>
							<label
								for=""
								placeholder="Word"
								alt="Word"></label>
						</div>
						<div class="line">&nbsp;</div>
						<div class="input-wrapper text-centered">
							<validated-input
								class="word-and-part text-centered"
								type="text"
								:debounce-delay="50"
								required
								v-model.trim="editWordAndPart"
								name="editWordAndPart"
								maxlength="22"></validated-input>
							<label
								for=""
								placeholder="Word + Word Part"
								alt="Word + Word Part"></label>
						</div>
					</div>
					<div class="text-centered">
						<button
							class="save-notif button"
							type="submit">
							Save
						</button>
						<button
							v-if="allowDelete"
							class="delete button -danger"
							type="button"
							@click="onDeleteNode">
							Delete
						</button>
						<button
							class="cancel-notif button -outline"
							type="button"
							@click="onEndEdit">
							Cancel
						</button>
					</div>
				</validated-form>
			</template>
		</modal>
	</div>
</template>
